export default __webpack_public_path__ + "assets/profeature-import-limit.63d1b227deb82f25ebcb1841833e4159.jpg";